<template>
  <v-container fluid class="px-0 py-0">
    <v-alert :value="empty" type="info">目前没有课件引用该视频</v-alert>
    <v-list two-line v-if="!empty && coursewares">
      <v-list-tile v-for="c in coursewares" :key="c.id">
        <v-list-tile-content>
          <v-list-tile-title>{{ c.name }}</v-list-tile-title>
          <v-list-tile-sub-title><label>机构</label><em>{{ c.orgName }} </em><label>状态</label><em>{{ c.status ? "激活" :
          "禁用" }}</em> <label>创建时间</label><em>{{ c.createTime | formatDatetime }}</em></v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-container>
</template>
<script>
export default {
  name: "media-refers",
  props: { cfg: Object },
  data() {
    return {
      empty: false,
      coursewares: null,
    };
  },
  methods: {
    init() {
      let self = this,
        mid = self.cfg.mediaId;
      self.$axios.get(`/home/admin/c/media/refers/${mid}`).then((r) => {
        r = r.data;
        if (!r || !r.message || r.message.length == 0) {
          self.empty = true;
          return;
        }

        let tHash = {},
          oHash = {};
        if (r.tenants && r.tenants.length > 0) {
          for (let t of r.tenants) {
            tHash[t.id] = t;
          }
        }
        if (r.orgs && r.orgs.length > 0) {
          for (let o of r.orgs) {
            oHash[o.id] = o;
          }
        }

        let cws = r.message;
        for (let cw of cws) {
          let t = tHash[cw.tenantId],
            o = oHash[cw.orgId];
          cw.orgName = (t ? t.name : "平台") + (o ? "-" + o.name : "");
        }
        self.coursewares = cws;
      });
    },
  },
  created() {
    this.init();
  },
};
</script>
<style scoped>
label {
  margin-left: 8px;
}

label::after {
  content: ":";
}

em {
  color: #0068b7;
}
</style>